import gql from 'graphql-tag';
import { COMPAIGN_FRAGMENT } from './fragment';

export const CREATE_COMPAIGN = gql`
  mutation CreateCompaign($input: CreateCompaignInput) {
    createCompaign(input: $input) {
      ...CompaignFragment
    }
  }
  ${COMPAIGN_FRAGMENT}
`;

export const SEND_MESSAGE_TO_COMPAIGN = gql`
  mutation SendMessageToCompaign($input: SendMessageToCompaignInput) {
    sendMessageToCompaign(input: $input)
  }
`;
